/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { WebConfiguration as __Configuration } from '../web-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { StationList } from '../models/station-list';
import { StationSearchOptions } from '../models/station-search-options';
import { Station } from '../models/station';

/**
 * All about the stations
 */
@Injectable({
  providedIn: 'root',
})
class StationsService extends __BaseService {
  static readonly searchStationsPath = '/stations/search';
  static readonly retrieveStationPath = '/stations/{uid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Search stations, with pagination
   *
   * Search stations, with pagination
   * @param params The `StationsService.SearchStationsParams` containing the following parameters:
   *
   * - `sortFieldName`: Indicates the field to use for sorting the data:
   *     * NAME : the station's name
   *     * CITY : the station's city
   *     * CODE : the station's code
   *
   * - `sortDirection`: Sort direction : ASC, DESC
   *
   * - `search`: The station search options object
   *
   * - `offset`: The list items offset
   *
   * - `limit`: The list items limit
   *
   * @return Success
   */
  searchStationsResponse(params: StationsService.SearchStationsParams): __Observable<__StrictHttpResponse<StationList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sortFieldName != null) __params = __params.set('sortFieldName', params.sortFieldName.toString());
    if (params.sortDirection != null) __params = __params.set('sortDirection', params.sortDirection.toString());
    __body = params.search;
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/stations/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StationList>;
      })
    );
  }
  /**
   * Search stations, with pagination
   *
   * Search stations, with pagination
   * @param params The `StationsService.SearchStationsParams` containing the following parameters:
   *
   * - `sortFieldName`: Indicates the field to use for sorting the data:
   *     * NAME : the station's name
   *     * CITY : the station's city
   *     * CODE : the station's code
   *
   * - `sortDirection`: Sort direction : ASC, DESC
   *
   * - `search`: The station search options object
   *
   * - `offset`: The list items offset
   *
   * - `limit`: The list items limit
   *
   * @return Success
   */
  searchStations(params: StationsService.SearchStationsParams): __Observable<StationList> {
    return this.searchStationsResponse(params).pipe(
      __map(_r => _r.body as StationList)
    );
  }

  /**
   * Retrieve a station
   *
   * Retrieve a station
   * @param uid The object ID. Must be a valid ID.
   * @return Success
   */
  retrieveStationResponse(uid: string): __Observable<__StrictHttpResponse<Station>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/stations/${encodeURIComponent(String(uid))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Station>;
      })
    );
  }
  /**
   * Retrieve a station
   *
   * Retrieve a station
   * @param uid The object ID. Must be a valid ID.
   * @return Success
   */
  retrieveStation(uid: string): __Observable<Station> {
    return this.retrieveStationResponse(uid).pipe(
      __map(_r => _r.body as Station)
    );
  }
}

namespace StationsService {

  /**
   * Parameters for searchStations
   */
  export interface SearchStationsParams {

    /**
     * Indicates the field to use for sorting the data:
     *   * NAME : the station's name
     *   * CITY : the station's city
     *   * CODE : the station's code
     */
    sortFieldName?: 'NAME' | 'CITY' | 'CODE';

    /**
     * Sort direction : ASC, DESC
     */
    sortDirection?: 'ASC' | 'DESC';

    /**
     * The station search options object
     */
    search?: StationSearchOptions;

    /**
     * The list items offset
     */
    offset?: number;

    /**
     * The list items limit
     */
    limit?: number;
  }
}

export { StationsService }
